const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const authService = {
    async signup(email, password, nickname) {
        const deviceToken = localStorage.getItem('deviceToken');
        const body = { email, password, nickname };
        const response = await fetch(`${API_BASE_URL}/api/auth/signup`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'X-Device-Token': deviceToken
             },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Signup failed');
        }
        const data = await response.json();
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('userEmail', data.email);
        localStorage.setItem('userNickname', data.nickname);
    },
    async login(email, password) {
        const deviceToken = localStorage.getItem('deviceToken');
        const body = { email, password };
        const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json', 
                'X-Device-Token': deviceToken
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Login failed');
        }
        const data = await response.json();
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('userEmail', data.email);
        localStorage.setItem('userNickname', data.nickname);
    },
    async sendVerificationCode(email) {
        const response = await fetch(`${API_BASE_URL}/api/auth/send-verification`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || '인증코드 발송에 실패했습니다');
        }

        return response.json();
    },

    async verifyEmail(email, code) {
        const response = await fetch(`${API_BASE_URL}/api/auth/verify-email`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, code })
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || '이메일 인증에 실패했습니다');
        }

        return response.json();
    },

    logout() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userNickname');
    },
    getToken() {
        return localStorage.getItem('authToken');
    },

    isLoggedIn() {
        return !!localStorage.getItem('authToken');
    },

    getUserEmail() {
        return localStorage.getItem('userEmail');
    },

    getUserNickname() {
        return localStorage.getItem('userNickname');
    },

    getDeviceToken() {
        return localStorage.getItem('deviceToken');
    },

    // 사용안하지만 참고용으로 남겨둠
    async deviceLogin() {
        const deviceToken = this.getDeviceToken();
        if (!deviceToken) {
            throw new Error('No device token available');
        }

        const response = await fetch(`${API_BASE_URL}/api/auth/device-login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Device-Token': deviceToken
            }
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Device login failed');
        }

        const data = await response.json();
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('userEmail', data.email);
        localStorage.setItem('userNickname', data.nickname);
        return data;
    }
};

export default authService;
